module.exports = __webpack_public_path__ + "static/emanagement2-b2d99558ebb23751c5c8e9f72f820512.png";